// Integrations — MCP access tokens for external agent frameworks
// (backend/modules/integrations). The token itself is returned once, on mint.
import { fetchData } from '../fetchapi/fetchapi';

// A body-less DELETE must not carry a JSON content-type: Fastify rejects an
// empty JSON body with FST_ERR_CTP_EMPTY_JSON_BODY.
const json = (method, body) => (body === undefined
  ? { method }
  : { method, headers: { 'Content-Type': 'application/json' }, body: JSON.stringify(body) });

export async function listMcpTokens() {
  return fetchData('integrations/mcp-tokens');
}
export async function mintMcpToken(label) {
  return fetchData('integrations/mcp-tokens', json('POST', { label }));
}
export async function revokeMcpToken(prefix) {
  return fetchData(`integrations/mcp-tokens/${encodeURIComponent(prefix)}`, json('DELETE'));
}
